<!-- <h4 class="title">Payment Details</h4> -->
<div class="row" style="margin-left: 0px;margin-right:0px;">
    <div class="col-md-12">
        <h4 class="title-f">Financial Details</h4>
    </div>
  
    <!-- <div class="col-md-4">
        <div class="search-hero">
            <input class="form-control" type="text" name="search2" style="font-family: FontAwesome;"
                [(ngModel)]="searchQR" autocomplete="off" placeholder="&#xf002; Search...">
        </div>
    </div> -->
    <div class="col-md-5">
        <h5 class="form-lable">Loan Number: <span>1234568908765432</span></h5>
    </div>
    <div class="col-md-5">
        <h5 class="form-lable">Customer Name: <span>Mohammed Imthiyas</span></h5>
    </div>
    <!-- <div class="col-md-2 text-right">
        <button type="button" class="btn btn-primary mr-0" (click)="show2()">Add</button>
    </div> -->
    <div class="col-md-12">
        <div class="doc-table">
            <table class="det-t">
                    <tr style="text-align: left;" class="th-b">
                        <th></th>
                        <th>Principal Amount</th>
                        <th>Interest Amount</th>
                        <th>LPC Amount</th>
                        <th>BCC Amount</th>
                        <th>Other Amount</th>
                        <th>Total Amount</th>
                    </tr>
                    <tr style="text-align: left;">
                        <th>Payment</th>
                        <td>39,078.91</td>
                        <td>25,699.90</td>
                        <td>0.00</td>
                        <td>0.00</td>
                        <td>480.00</td>
                        <td>65,258.81</td>
                    </tr>
                    <tr style="text-align: left;">
                        <th>Overdue</th>
                        <td>39,078.91</td>
                        <td>25,699.90</td>
                        <td>0.00</td>
                        <td>0.00</td>
                        <td>480.00</td>
                        <td>65,258.81</td>
                    </tr>
                    <tr style="text-align: left;">
                        <th>Reversal</th>
                        <td>39,078.91</td>
                        <td>25,699.90</td>
                        <td>0.00</td>
                        <td>0.00</td>
                        <td>480.00</td>
                        <td>65,258.81</td>
                    </tr>
                    <tr style="text-align: left;">
                        <th>Outstanding</th>
                        <td>39,078.91</td>
                        <td>25,699.90</td>
                        <td>0.00</td>
                        <td>0.00</td>
                        <td>480.00</td>
                        <td>65,258.81</td>
                    </tr>
                    
            </table>
        </div>
    </div>
</div>

<br>
